import React, { useMemo } from 'react';
import { DataGrid } from '../../DataGrid';
import { SingleColumnGridProps } from '../types';
import { getFields } from '../utils';
import './SingleColumnGrid.scss';

export const SingleColumnGrid: React.FC<SingleColumnGridProps> = ({
  title,
  dataFromApi,
  onCellPrepared,
  height,
  customizeText,
  showColumnHeaders = false,
  customizeCaptions,
}) => {
  const fields = useMemo(
    () => getFields({ customizeText, customizeCaptions }),
    [customizeText, customizeCaptions]
  );
  const setHeightValue = useMemo(() => `${height || '100%'}`, [height]);

  return (
    <div className="single-column-grid">
      <DataGrid
        title={title}
        dataSource={dataFromApi}
        fields={fields}
        showBorders
        height={setHeightValue}
        showRowLines
        showColumnHeaders={showColumnHeaders}
        onCellPrepared={onCellPrepared}
      />
    </div>
  );
};
